'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseApi = require('./base_api');
var defer = require('../defer');

var MiscApi = function (_BaseApi) {
  _inherits(MiscApi, _BaseApi);

  function MiscApi(transmitter, receiver) {
    _classCallCheck(this, MiscApi);

    var _this = _possibleConstructorReturn(this, (MiscApi.__proto__ || Object.getPrototypeOf(MiscApi)).call(this, transmitter));

    _this.deferreds = {};
    _this.timeoutIds = {};
    receiver.addMessageHandler('navigate:response', _this.handleResponse.bind(_this));
    receiver.addMessageHandler('get_url:response', _this.handleResponse.bind(_this));
    return _this;
  }

  _createClass(MiscApi, [{
    key: 'handleResponse',
    value: function handleResponse(message) {
      if (message.source.integration_id === BaseApi.EMARSYS) {
        if (this.deferreds[message.data.id]) {
          clearTimeout(this.timeoutIds[message.data.id]);
          if (message.data.success) {
            this.deferreds[message.data.id].resolve(message);
          } else {
            this.deferreds[message.data.id].reject(message);
          }
        }
      }
    }
  }, {
    key: 'fit',
    value: function fit() {
      this.transmitter.messageToEmarsys('fit');
    }
  }, {
    key: 'resize',
    value: function resize(height) {
      this.transmitter.messageToEmarsys('resize', {
        height: height
      });
    }
  }, {
    key: 'track',
    value: function track(options) {
      this.transmitter.messageToEmarsys('track', options);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.transmitter.messageToEmarsys('refresh', {});
    }
  }, {
    key: 'enableButton',
    value: function enableButton(selector) {
      this.transmitter.messageToEmarsys('enable_button', {
        selector: selector
      });
    }
  }, {
    key: 'navigate',
    value: function navigate(eventPayload) {
      return this.sendMessage('navigate', eventPayload);
    }
  }, {
    key: 'getUrl',
    value: function getUrl(eventPayload) {
      return this.sendMessage('get_url', eventPayload);
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(eventName, eventPayload) {
      var _this2 = this;

      var eventId = this.getRandomId();
      this.deferreds[eventId] = defer();

      this.timeoutIds[eventId] = setTimeout(function () {
        console.error('No response received for integrationClient request within ' + _this2.getResponseTimeout() + 'ms. Make sure emarsys-integration-js is included in the top iframe.');
        var myWindow = _this2.transmitter.global;
        var isIFrame = myWindow.self !== myWindow.top;
        var errorMessage = void 0;
        if (!isIFrame && (!myWindow.Emarsys || !myWindow.Emarsys.integration)) {
          errorMessage = 'No response received for integrationClient within timeout, emarsys-integration-js is missing';
        } else {
          errorMessage = 'No response received for integrationClient within timeout';
        }
        _this2.deferreds[eventId].reject(new Error(errorMessage));
      }, this.getResponseTimeout());

      this.transmitter.messageToEmarsys(eventName, Object.assign({}, eventPayload, { eventId: eventId }));
      return this.deferreds[eventId].promise;
    }
  }, {
    key: 'getResponseTimeout',
    value: function getResponseTimeout() {
      return 2000;
    }
  }], [{
    key: 'create',
    value: function create(transmitter, receiver) {
      var api = new MiscApi(transmitter, receiver);

      return api.exposeMethods(['enableButton', 'fit', 'getUrl', 'navigate', 'refresh', 'resize', 'track']);
    }
  }]);

  return MiscApi;
}(BaseApi);

module.exports = MiscApi;


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/client/misc_api.js
 ** module id = 8
 ** module chunks = 0 1
 **/